export const getDecisionTreeList = () => ({apis}) => {
  let payload = apis.getDecisionTreeList().map((x) => x)
  return {
    type: 'GET_COMPANY_TREE_LIST',
    payload,
  }
}

export const getDecisionTreeDetails = (provinerId, companyId, data) => ({apis}) => {
  let payload = apis.getDecisionTreeData(provinerId, companyId)(data).map((x) => x)
  return {
    type: 'GET_DECISION_TREE_DATA',
    payload,
  }
}

export const getDecisionTreeUserFields = (provenirId) => ({apis}) => {
  let payload = apis.getDecisionTreeDataFields(provenirId).map((x) => x)
  return {
    type: 'GET_DECISION_TREE_USER_FIELDS',
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/decision-tree/actions.js